import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "@fortawesome/fontawesome-free/css/all.css";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import "@/assets/styles/global.css";

// Detectăm prerender (rulează în HeadlessChrome)
const isPrerender =
  typeof navigator !== "undefined" && /HeadlessChrome/i.test(navigator.userAgent);

// Dacă în prerender se fac request-uri și pică, nu vrem să pice TOT build-ul.
// Le “îmblânzim” ca să returneze răspuns gol în loc de crash.
if (isPrerender && typeof window !== "undefined" && typeof window.fetch === "function") {
  const origFetch = window.fetch.bind(window);
  window.fetch = (...args) =>
    origFetch(...args).catch(() => {
      // răspuns “safe” pentru request-uri care pică în prerender
      return new Response("{}", {
        status: 200,
        headers: { "Content-Type": "application/json" },
      });
    });
}

const app = createApp(App);
app.use(router);

router.isReady().then(() => {
  app.mount("#app");
  // semnal pentru prerender că pagina e gata
  document.dispatchEvent(new Event("render-event"));
});
